import React, { useEffect, useContext } from 'react'
import { useParams } from 'react-router-dom'
import Button from '@material-ui/core/Button'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import LineIcon from '../images/line-chat-icon.svg'

// layout
import Layout from '../layout'

// components
import ClubDetails from '../components/ClubDetails'
import Divider from '../components/Divider'

// styles
import { useStyles } from '../styles/common.style'

// store
import { Context } from '../store'
import types from '../store/types'

// utils
import { redirectToGym } from '../utils'
import { t } from 'application-translator/dist/translate/translate.react.js';


function Home() {
  const classes = useStyles()

  // store
  const { globalState, dispatch } = useContext(Context)
  const { loadingClub, clubData } = globalState
  const {
    id: clubId,
    name: clubName,
    placeData = {},
    gmbPlaceId,
    lineChat
  } = clubData || {}
  const { btnUrl } = lineChat || {};
  const countryIso = placeData?.country?.iso_code;

  // router hooks
  const { clubId: paramClubId } = useParams()

  // toggle workout
  const toggleWorkoutModal = () => {
    dispatch({ type: types.TOGGLE_WORKOUT_MODAL })
  }

  useEffect(() => {
    // redirect when there's no clubId in the url
    if (!paramClubId) {
      redirectToGym();
    }
  }, [paramClubId])

  return (
    <Layout
      header={
        <ClubDetails club={clubName} address={placeData?.formatted_address} isLoading={loadingClub} />
      }
      hasContent={typeof clubName !== 'undefined'}
    >
      {!loadingClub && clubName && (
      <div className={classes.content}>
        <div className={classes.grp}>
          <Button
            variant="outlined"
            endIcon={<ArrowForwardIcon />}
            href={`${process.env.REACT_APP_SITE_URL}/signup/${clubId}`}
            target="_blank"
          >
            {t('Signup')}
          </Button>
          <Button
            variant="outlined"
            endIcon={<ArrowForwardIcon />}
            onClick={toggleWorkoutModal}
          >
            {t('Book a free trial')}
          </Button>
          {btnUrl && (
            <Button
              variant="outlined"
              endIcon={<img src={LineIcon} alt="" style={{ width: 24 }} />}
              href={btnUrl}
              target='_blank'
            >
              {t('Chat with us on Line')}
            </Button>
          )}
        </div>
        <Divider />
        <div className={classes.grp}>

          {countryIso !== 'JP' && (
            <Button
              variant="outlined"
              endIcon={<ArrowForwardIcon />}
              href={`https://ubx.fit/train/?utm_source=links&utm_campaign=${clubId}`}
              target="_blank"
            >
              {t('Train: on Demand')}
            </Button>
          )}
          
          <Button
            variant="outlined"
            endIcon={<ArrowForwardIcon />}
            href={`https://ubx.fit/memberapp/?utm_source=links&utm_campaign=${clubId}`}
            target="_blank"
          >
            {t('UBX Member App')}
          </Button>

          {countryIso !== 'JP' && (
            <Button
              variant="outlined"
              endIcon={<ArrowForwardIcon />}
              href={`https://ubx.fit/tc/?utm_source=links&utm_campaign=${clubId}`}
              target="_blank"
            >
              {t('Training Camp App')}
            </Button>
          )}
        </div>

        {gmbPlaceId && (
          <>
            <Divider />
            <Button
              variant="outlined"
              endIcon={<ArrowForwardIcon />}
              target="_blank"
              href={`https://search.google.com/local/writereview?placeid=${gmbPlaceId}`}
            >
              {t('Leave a review')}
            </Button>
          </>
        )}
      </div>
      )}
    </Layout>
  )
}

export default Home
